// extracted by mini-css-extract-plugin
export var numpadContainer = "_sf-1";
export var phoneButton = "_sf-0";